import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Message } from '../../case/model/message';

@Injectable({
  providedIn: 'root'
})
export class MessageService
{

  constructor(private http: HttpClient) { }

  /**
   * Get message by id.
   */
  public getMessageById(id: number): Observable<Message>
  {
    return this.http.get<Message>(`/messages/${id}`);
  }

  /**
   * Get count messages by user and status.
   */
  public getCountMessageByUserAndStatus(username: string, status: number): Observable<number>
  {
    return this.http.get<number>(`/messages/count/${username}/${status}`);
  }

  /**
   * Persist a Message in the database.
   *
   * @param data Data to save
   */
  public saveMessage(data: Message): Observable<any>
  {
    return this.http.post('/messages', data);
  }

  /**
   * Persist a Message in the database.
   *
   * @param data Data to save
   */
  public saveMessageIndirect(data: Message): Observable<any>
  {
    return this.http.post('/messages/indirect', data);
  }

  /**
   * Get messages by cases.
   */
  public getMessagesByCase(caseId: string): Observable<Message[]>
  {
    return this.http.get<Message[]>(`/messages/case/${caseId}`);
  }

  /**
   * Delete messages selected.
   */
  public deleteMessages(data: Message[]): Observable<any>
  {
    return this.http.put('/messages/delete', data);
  }

  /**
   * Undelete messages
   */
  public undeleteMessages(data: Message[]): Observable<any>
  {
    return this.http.put('/messages/undelete', data);
  }

  /**
   * Erase messages
   */
  public eraseMessages(data: Message[]): Observable<any>
  {
    return this.http.put('/messages/erase', data);
  }

  /**
   * Update messages selected.
   */
  public updateMessages(data: Message[]): Observable<any>
  {
    return this.http.put('/messages/update', data);
  }
}
